// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fc-badge[data-v-e1bfbd4a] {\n  background-color: black;\n  color: white;\n  padding: 2px;\n  font-size: 10px;\n  width: 30px;\n  height: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
